import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Container from '../Container/Container';
import { BreakpointUpMedium } from '../../styles/Breakpoints';

const Hero = ({ marginBottom, title, description, children }) => {
  return (
    <Section marginBottom={marginBottom}>
      <VerticalGlow />
      <RadialGlow />

      <Container>
        <ContentBox>
          <h1>{title}</h1>
          {description && <p>{description}</p>}
          {children}
        </ContentBox>
      </Container>
    </Section>
  );
};

export default Hero;

Hero.propTypes = {
  children: PropTypes.node,
  description: PropTypes.string,
  marginBottom: PropTypes.number,
  title: PropTypes.string.isRequired,
};

Hero.defaultProps = {
  children: null,
  description: '',
  marginBottom: 0,
};

const Section = styled.section`
  position: relative;
  overflow: hidden;
  padding: 128px 16px 16px;
  ${({ marginBottom }) => marginBottom && css`
    margin-bottom: ${marginBottom}px;
  `}

  ${BreakpointUpMedium} {
    padding-top: 128px;
    padding-bottom: 16px;
  }
`;

const VerticalGlow = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, hsl(263 70% 60% / 0.1) 0%, hsl(222 47% 6%) 55%, hsl(222 47% 6%) 100%);
  pointer-events: none;
`;

const RadialGlow = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at top, hsl(263 70% 60% / 0.2) 0%, hsl(222 47% 6%) 60%, hsl(222 47% 6%) 100%);
  pointer-events: none;
`;

const ContentBox = styled.div`
  position: relative;
  z-index: 1;
  max-width: 880px;
  margin: 0 auto;
  text-align: center;

  h1 {
    margin: 0 0 24px;
    background: linear-gradient(135deg, hsl(263 70% 60%), hsl(190 95% 45%));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 3rem;
    font-weight: 700;
    line-height: 1.1;
    letter-spacing: -0.025em;
  }

  p {
    max-width: 672px;
    margin: 0 auto;
    color: hsl(215 20% 75%);
    font-family: 'Rajdhani', sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.75rem;
    letter-spacing: 0.025em;
  }

  ${BreakpointUpMedium} {
    h1 {
      font-size: 4.5rem;
    }

    p {
      font-size: 20px;
    }
  }
`;
